import { render, staticRenderFns } from "./SimpleToggle.vue?vue&type=template&id=4359b84c&scoped=true"
import script from "./SimpleToggle.vue?vue&type=script&lang=js"
export * from "./SimpleToggle.vue?vue&type=script&lang=js"
import style0 from "./SimpleToggle.vue?vue&type=style&index=0&id=4359b84c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4359b84c",
  null
  
)

export default component.exports